import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';
import { environment } from '../../environments/environment';

export const authGuard: CanActivateFn = async () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  await auth.whenReady();

  if (environment.featureFlags?.skipLogin || auth.isAuthenticated()) {
    return true;
  }

  return router.createUrlTree(['/login']);
};

export const practiceGuard: CanActivateFn = async () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  await auth.whenReady();

  if (environment.featureFlags?.skipLogin || auth.hasPractice()) {
    return true;
  }

  return router.createUrlTree(['/practice-selection']);
};

export const onboardingGuard: CanActivateFn = async () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  await auth.whenReady();

  if (environment.featureFlags?.skipLogin) return true;
  if (!auth.isAuthenticated()) return router.createUrlTree(['/login']);
  if (auth.profileSetupComplete()) return true;

  return router.createUrlTree(['/onboarding']);
};

export const loginRedirectGuard: CanActivateFn = async () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  await auth.whenReady();

  if (!auth.isAuthenticated()) {
    return true;
  }

  if (!auth.profileSetupComplete()) {
    return router.createUrlTree(['/onboarding']);
  }

  return router.createUrlTree(['/practice-selection']);
};
